/**
 * Feedback / NPS survey API client.
 */
import { apiGet, apiPost } from "./client.ts";

export interface FeedbackSubmission {
  score: number;        // 0-10 NPS scale
  comment: string;      // free-text
  trigger: string;      // e.g. "day7", "post_publish", "manual"
}

export interface FeedbackEntry {
  id: string;
  userId: string;
  userEmail: string;
  score: number;
  comment: string;
  trigger: string;
  createdAt: string;
}

export const feedbackApi = {
  /** Submit NPS feedback. */
  submit: (data: FeedbackSubmission) =>
    apiPost<{ ok: boolean }>("/feedback", data),

  /** Check if user should see the survey (hasn't submitted in last 30 days). */
  shouldShow: () =>
    apiGet<{ show: boolean; trigger: string }>("/feedback/should-show"),

  /** Dismiss the survey for now (snooze 7 days). */
  dismiss: () =>
    apiPost<{ ok: boolean }>("/feedback/dismiss"),

  /** Admin: list all feedback entries. */
  adminList: (params: { limit?: number; offset?: number } = {}) => {
    const qs = new URLSearchParams();
    if (params.limit) qs.set("limit", String(params.limit));
    if (params.offset) qs.set("offset", String(params.offset));
    const q = qs.toString();
    return apiGet<{
      entries: FeedbackEntry[];
      stats: { avgScore: number; promoters: number; passives: number; detractors: number; nps: number };
      pagination: { limit: number; offset: number; total: number };
    }>(`/admin/feedback${q ? `?${q}` : ""}`);
  },
};
